// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { formatCurrencyIndian } from "../CustomFunctions";
// import { formattedDateLong } from "../Date";
// import { fetchExistingLetterTemplate, numberToIndianWords } from "../CustomUtilities";
// import { toast } from "react-toastify";
// import TemplateDisplayWrapper from "../DynamicBuilders/LetterDisplayComponents/TemplateDisplayWrapper";
// import { LetterPreview } from "../DynamicBuilders/LetterDisplayComponents/LetterPreview";

// const CurrentSalarySlip = () => {
//   const [subCompany, setSubCompany] = useState({});
//   const [letterTemplateData, setLetterTemplateData] = useState({});
//   const [buffer, setBuffering] = useState(false);
//   const location = useLocation();
//   const { i, monthh, yearr } = location.state;
//   const [getSubCompanyId, setSubCompanyId] = useState(i?.saved_salary_data?.salary_data?.emp_data?.division)
//   const [isClient, setIsClient] = useState(false);
//   const ref = useRef();
//   useEffect(() => {
//     setIsClient(true);
//   }, []);

//   const monthNames = [
//     "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY",
//     "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
//   ];

//   const monthName = monthNames[monthh - 1];


//   const loadLetterTemplate = async () => {
//     setBuffering(true);
//     try {
//       const { template, subcompany } = await fetchExistingLetterTemplate({
//         letterTemplateId: i?.
//           saved_salary_data?.salary_data
//           ?.emp_data?.letter_template,
//         emp_code: i?.emp_code,
//         subcompanyId: i?.saved_salary_data?.salary_data?.emp_data?.division,
//       });
//       setLetterTemplateData(template);
//       if (subcompany) setSubCompany(subcompany);
//     } catch (err) {
//       toast.warning("Could not fetch letter template");
//     }
//     finally {
//       setBuffering(false)
//     }
//   };

//   useEffect(() => {
//     loadLetterTemplate();
//   }, [i?.emp_code, getSubCompanyId, i?.
//     saved_salary_data?.salary_data
//     ?.emp_data?.letter_template]);


//   const navigate = useNavigate()
//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split('/');

//   const filter_subCompany = location.state ? location.state.filters.subCompany : "";
//   const filter_status = location.state ? location.state.filters.active : "";
//   const filter_CostCenter = location.state ? location.state.filters.selectedCostCenter : "";
//   const filter_DataType = location.state ? location.state.filters.selectedDataType : "";
//   const filter_Department = location.state ? location.state.filters.selectedDep : "";
//   const filter_Designation = location.state ? location.state.filters.selectedDesi : "";
//   const filter_Name = location.state ? location.state.filters.selectedName : "";
//   const filter_Month = location.state ? location.state.filters.startMonth : "";
//   const filter_Year = location.state ? location.state.filters.startYear : "";

//   const backUrl = "/" + urlParts[3] + `/payrollmanagement`;
//   const togglepayroll = 2;
//   const toggleincomingmonth = monthh;
//   const toggleincomingyear = yearr;

//   const backroute = () => {
//     navigate(backUrl, {
//       state: {
//         togglepayroll: 2,
//         filter_subCompany,
//         filter_status,
//         filter_CostCenter,
//         filter_DataType,
//         filter_Department,
//         filter_Designation,
//         filter_Name,
//         filter_Month,
//         filter_Year,
//         toggleincomingmonth,
//         toggleincomingyear
//       }
//     });
//   };


//   const contentData = (
//     <>
//       <div className='printSlip-header-left-text  font-size-heading' style={{ padding: '2px 0px', marginBottom: '20px' }}>
//         SALARY SLIP FOR THE MONTH OF {monthName} {yearr}
//       </div>
//       <div className='salaryslip-header-second' style={{ margin: '0px' }}>
//         <div className='salaryslip-header-second-section1'>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>NAME</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>FATHER / HUSBAND</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DATE OF JOINING</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DEPARTMENT</div>
//         </div>
//         <div className='salaryslip-header-second-section2'>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading '>{i?.employee_details?.emp_name}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.current_salary_calculation
//             ?.user_details?.father_name ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.employee_details
//             ?.joining_date ? formattedDateLong(i.employee_details
//               ?.joining_date) : "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.employee_details
//             ?.department_name ?? "-"}</div>
//         </div>
//         <div className='salaryslip-header-second-section3'>
//         </div>
//         <div className='salaryslip-header-secondsection4'>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>CODE</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>BANK</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>ACCOUNT NO.</div>
//           <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>IFSC NO.</div>
//           {/* <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>UAN NO.</div> */}
//         </div>
//         <div className='salaryslip-header-second-section5'>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.emp_code}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.bank_name ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.account_number ?? "-"}</div>
//           <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.ifsc_code ?? "-"}</div>
//           {/* <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.bank_details.branch_address}</div> */}
//         </div>
//       </div>
//       <div className='salaryslip-hr' style={{ marginTop: '20px' }}></div>
//       <div className='salaryslip-header-third' style={{ margin: '20px 0px', padding: '0px' }}>
//         <div className='salaryslip-header-third-section1'>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL DAYS</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL LEAVES</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL ABSENT</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WORKING DAYS</div>
//         </div>
//         <div className='salaryslip-header-third-section2'>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_days}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.leave}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.absent}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_paid_days}</div>


//         </div>
//         <div className='salaryslip-header-third-section3'>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WEEKLY OFF</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>LEAVE WITHOUT PAY</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>HOLIDAY</div>
//           <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>NET PAID DAYS</div>

//         </div>
//         <div className='salaryslip-header-third-section4'>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.weeklyoff}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.unpaidleave}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.holiday}</div>
//           <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_paid_days}</div>
//         </div>
//       </div>
//       {/* <div className='salaryslip-hr' ></div> */}
//       <div className='salaryslip-body'>
//         <table className='nested-table-modern nested-table-outer' style={{ marginTop: '0px', marginBottom: '0px' }}>
//           <thead>
//             <tr className='slaryslip-head'>
//               {/* <th >S. No.</th> */}
//               <th className="align-center" style={{ width: "260px", padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }}>SALARY COMPONENT</th>
//               <th className="align-center" style={{ padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }} >STANDARD</th>
//               <th className="align-center" style={{ padding: "14px 5px", textAlign: 'center', backgroundColor: '#dcedff', fontWeight: 'bold' }}>AMOUNT</th>
//             </tr>
//           </thead>
//           <tbody>
//             {
//               i?.current_salary_calculation?.deduction_details
//                 ?.filter((j) => !isNaN(j.standard_amount) && !isNaN(j.actual_amount) && j.salaryslip !== false)
//                 .sort((a, b) => a.sorting_var - b.sorting_var)
//                 .map((j, index) => {
//                   const isSpecialRow = j.salary_type === "total" || j.salary_type === "difference";
//                   return (
//                     <>
//                       <tr key={index} className={isSpecialRow ? "special-row" : "gray-row"}>
//                         <td>{j.name}</td>
//                         <td className="align-right">{formatCurrencyIndian(j.standard_amount)}</td>
//                         <td className="align-right">{formatCurrencyIndian(j.actual_amount)}</td>
//                       </tr>

//                     </>
//                   );
//                 })
//             }
//           </tbody>
//         </table>
//         <table className='nested-table-modern ' style={{ marginTop: '20px', marginBottom: '0px' }}>
//           <tbody>
//             <tr className="salary-total-row">
//               <td colSpan={1}>SALARY PAY</td>
//               <td colSpan={3}>
//                 {
//                   formatCurrencyIndian(
//                     i?.current_salary_calculation?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
//                   )
//                 }
//               </td>
//             </tr>
//             {/* <tr className="salary-total-row in-words-row">
//                 <td colSpan={1}>IN WORDS</td>
//                 <td colSpan={3}>
//                   {
//                     numberToWords.toWords(
//                       i.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
//                     ).toUpperCase()
//                   }
//                 </td>
//               </tr> */}<tr className="salary-total-row in-words-row">
//               <td colSpan={1}>IN WORDS</td>
//               <td colSpan={3}>
//                 {/* {
//                       (() => {
//                         const amountStr = i.deduction_details.find((j) => j.final_salary)?.actual_amount;
//                         const amount = Number(amountStr.replace(/,/g, ''));
//                         if (!isNaN(amount) && isFinite(amount)) {
//                           return numberToIndianWords(5000000).toUpperCase() + " ONLY";
//                         } else {
//                           return "---";
//                         }
//                       })()
//                     } */}
//                 {
//                   (() => {
//                     const detail = i?.current_salary_calculation?.deduction_details.find((j) => j.final_salary);
//                     const amountStr = detail?.actual_amount;

//                     if (typeof amountStr === 'number' && isFinite(amountStr)) {
//                       const amount = amountStr;
//                       return numberToIndianWords(amount).toUpperCase() || '-';
//                     } else if (typeof amountStr === 'string') {
//                       const amount = Number(amountStr.replace(/,/g, ''));
//                       if (!isNaN(amount) && isFinite(amount)) {
//                         return numberToIndianWords(amount).toUpperCase() || '-';
//                       }
//                     }

//                     return "---";
//                   })()
//                 }

//               </td>
//             </tr>


//           </tbody>
//         </table>
//       </div>
//     </>
//   )

//   return (
//     <>
//       <TemplateDisplayWrapper
//         onBack={backroute}
//         // fontSize={16}
//         ref={ref}
//         downloadEnable={false}
//       >
//       </TemplateDisplayWrapper >
//       <LetterPreview
//         letterTemplateData={letterTemplateData}
//         subCompany={subCompany}
//         buffer1={buffer}
//         ref={ref}
//         // fontSize={16}
//         lineHeight={1.5}
//         showDefaultSignText={true}
//       >
//         {contentData}
//       </LetterPreview>
//     </>


//   )
// }

// export default CurrentSalarySlip;

import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import numberToWords from 'number-to-words';
import { formatCurrencyIndian, renderDangerousHTML } from "../CustomFunctions";
import { formattedDateLong } from "../Date";
import { Printer } from "../AllSvg";
import { fetchExistingLetterTemplate, numberToIndianWords } from "../CustomUtilities";
import { toast } from "react-toastify";

const DataSalarySlip = React.forwardRef((props, ref) => {
  const [subCompany, setSubCompany] = useState({});
  const [letterTemplateData, setLetterTemplateData] = useState({});

  let { month, year, id } = useParams();
  const location = useLocation();
  const { i, monthh, yearr } = location.state;
  const [getSubCompanyId, setSubCompanyId] = useState(i?.saved_salary_data?.salary_data?.emp_data?.division)

  const monthNames = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY",
    "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
  ];

  const monthName = monthNames[monthh - 1];

  const loadLetterTemplate = async () => {

    try {
      // const { template, subcompany } = await fetchExistingLetterTemplate({
      //   letterTemplateId: i?.emp_data?.letter_template, //checked
      //   subcompanyId: getSubCompanyId,
      //   emp_code: i?.emp_code,
      // });
      const { template, subcompany } = await fetchExistingLetterTemplate({
        letterTemplateId: i?.
          saved_salary_data?.salary_data
          ?.emp_data?.letter_template || null,
        emp_code: i?.emp_code,
        subcompanyId: i?.saved_salary_data?.salary_data?.emp_data?.division || i?.sub_company_id
          || i?.sub_company,
        // subcompanyId: i?.saved_salary_data?.salary_data?.emp_data?.division,
      });
      setLetterTemplateData(template);
      if (subcompany) setSubCompany(subcompany);
    } catch (err) {
      toast.warning("Could not fetch letter template");
    }
  };

  // useEffect(() => {

  //   loadLetterTemplate();

  // }, [i?.sub_company, i?.emp_code, getSubCompanyId]);


  useEffect(() => {
    loadLetterTemplate();
  }, [
    // i?.emp_code, i?.saved_salary_data?.salary_data?.emp_data?.division || i?.sub_company_id  
    // || i?.sub_company, i?.
    // saved_salary_data?.salary_data
    // ?.emp_data?.letter_template
    i?.emp_code,
    i?.saved_salary_data?.salary_data?.emp_data?.division,
    i?.sub_company_id,
    i?.sub_company,
    i?.saved_salary_data?.salary_data?.emp_data?.letter_template
  ]);


  return (

    <div ref={ref} style={{
      // ...getPaperDimensions(letterTemplateData?.page_size || "A4"),

      width: '210mm',
      position: "relative",
      height: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>


      <div
        // className='salaryslip'
        className='letterslip  letterslip-outer'


      >


        {(letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email || letterTemplateData?.header_full_image)
          ?
          (
            letterTemplateData?.header_full_image ? (
              <div className='salaryslip-header'
                style={{
                  paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                  paddingRight: `${letterTemplateData?.header_right_gap}px`,
                  paddingTop: `${letterTemplateData?.header_top_gap}px`,
                  paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                }}
              >
                <img src={`${letterTemplateData?.header_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
              </div>
            )
              :
              (
                (letterTemplateData?.header_logo || letterTemplateData?.header_company_name || letterTemplateData?.header_Address || letterTemplateData?.header_email) &&
                (
                  <>
                    <div className='salaryslip-header'
                      style={{
                        paddingLeft: `${letterTemplateData?.header_left_gap}px`,
                        paddingRight: `${letterTemplateData?.header_right_gap}px`,
                        paddingTop: `${letterTemplateData?.header_top_gap}px`,
                        paddingBottom: `${letterTemplateData?.header_bottom_gap}px`,

                      }}
                    >
                      <div className='salaryslip-header-left'>
                        {!letterTemplateData?.header_full_image &&
                          letterTemplateData?.header_logo ? (
                          <img src={`${letterTemplateData?.header_logo}`} alt='logo' className='salaryslip-logo' />
                        ) : (
                          ''
                        )
                        }

                      </div>
                      <div className='salaryslip-header-right text-end'>

                        {
                          letterTemplateData?.header_company_name ? (
                            <div className={`salaryslip-header-right-top-red font-weight600 font-size-heading`} style={{ color: letterTemplateData?.header_primary_colour || 'black' }}>
                              {letterTemplateData?.header_company_name}
                            </div>
                          ) : (
                            ''
                          )}

                        {
                          (letterTemplateData?.header_Address || letterTemplateData?.header_email) && (
                            <>
                              <div style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400  font-size-subheading letter-address' dangerouslySetInnerHTML={{ __html: letterTemplateData?.header_Address }}>

                              </div>
                              <span className="letter-address" style={{ color: letterTemplateData?.header_secondery_colour || '#212529' }}> {letterTemplateData?.header_email} </span>

                            </>
                          )

                        }
                      </div>
                    </div>
                    {!letterTemplateData?.header_full_image && (<div className='salaryslip-hr mb-2'></div>)}
                  </>
                )
              )
          ) :
          (
            <>
              <div className='salaryslip-header' style={{ padding: '10px' }}>
                {subCompany?.company_logo && (
                  <div className='salaryslip-header-left'>
                    <img src={subCompany?.company_logo} alt={subCompany?.title} className='salaryslip-logo' />
                  </div>
                )}
                <div className='salaryslip-header-right'>
                  {subCompany?.company_name && (
                    <div className='printSlip-header-right-top  font-weight600   font-size-heading' style={{ marginBottom: '5px', textAlign: 'end' }}>
                      {subCompany?.company_name}
                    </div>
                  )}
                  <div className='salaryslip-header-right-bottom  font-weight400  font-size-subheading'>
                    {/* {subCompany?.company_address && (
                      <div className='slip-top-right-content' style={{ textAlign: 'right' }} dangerouslySetInnerHTML={{ __html: subCompany?.company_address }} />
                    )} */}
                    <div className='slip-top-right-content'>
                      {renderDangerousHTML(subCompany?.company_address)}
                    </div >
                  </div>
                </div>
              </div>
              <div className='salaryslip-hr'></div>
            </>
          )
        }

        <div className='content-container'
          style={{
            paddingLeft: `${letterTemplateData?.content_left_gap || 20}px`,
            paddingRight: `${letterTemplateData?.content_right_gap || 20}px`,
            paddingTop: !letterTemplateData?.id && '20px',
            paddingBottom: !letterTemplateData?.id && '20px',
            overflow: 'hidden',
            wordWrap: "break-word",
            // minHeight: '165vh',
            // height: 'auto'
          }}>
          <div className='printSlip-header-left-text  font-size-heading' style={{ padding: '0px 0px', margin: '20px' }}>
            SALARY SLIP FOR THE MONTH OF {monthName} {yearr}
          </div>
          {/* <div className='printSlip-hr' ></div> */}
          <div className='salaryslip-header-second'>
            <div className='salaryslip-header-second-section1'>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>NAME</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>FATHER / HUSBAND</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DATE OF JOINING</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>DEPARTMENT</div>
            </div>
            <div className='salaryslip-header-second-section2'>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading '>{i?.employee_details?.emp_name}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.current_salary_calculation
                ?.user_details?.father_name ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.employee_details
                ?.joining_date ? formattedDateLong(i.employee_details
                  ?.joining_date) : "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.employee_details
                ?.department_name ?? "-"}</div>
            </div>
            <div className='salaryslip-header-second-section3'>
            </div>
            <div className='salaryslip-header-secondsection4'>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>CODE</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>BANK</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>ACCOUNT NO.</div>
              <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>IFSC NO.</div>
              {/* <div className='salaryslip-heading-black   font-weight600 font-size-subheading'>UAN NO.</div> */}
            </div>
            <div className='salaryslip-header-second-section5'>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.emp_code}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.bank_name ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.account_number ?? "-"}</div>
              <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i?.bank_details?.ifsc_code ?? "-"}</div>
              {/* <div className='salaryslip-heading-black1  font-weight400  font-size-subheading'>{i.bank_details.branch_address}</div> */}
            </div>
          </div>
          <div className='salaryslip-hr'></div>
          <div className='salaryslip-header-third'>
            <div className='salaryslip-header-third-section1'>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL DAYS</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL LEAVES</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>TOTAL ABSENT</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WORKING DAYS</div>
            </div>
            <div className='salaryslip-header-third-section2'>
              {/* <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_days}</div> */}
              <div className='salaryslip-heading-blue font-weight500'>
                {monthName === 'MAY' ? 24 : i?.current_salary_calculation?.total_days}
              </div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.leave}</div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.absent}</div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_paid_days}</div>


            </div>
            <div className='salaryslip-header-third-section3'>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>WEEKLY OFF</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>LEAVE WITHOUT PAY</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>HOLIDAY</div>
              <div className='salaryslip-heading-blue font-weight500 font-size-subheading'>NET PAID DAYS</div>

            </div>
            <div className='salaryslip-header-third-section4'>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.weeklyoff}</div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.unpaidleave}</div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.attendance_summary?.holiday}</div>
              <div className='salaryslip-heading-blue font-weight500'>{i?.current_salary_calculation?.total_paid_days}</div>
            </div>
          </div>
          <div className='salaryslip-hr'></div>
          <div className='salaryslip-body'>
            <table className='nested-table-modern nested-table-outer'>
              <thead>
                <tr className='slaryslip-head'>
                  {/* <th >S. No.</th> */}
                  <th className="align-center" style={{ width: "260px", padding: "0px 5px" }}>SALARY COMPONENT</th>
                  <th className="align-center" >STANDARD</th>
                  <th className="align-center" >AMOUNT</th>
                </tr>
              </thead>
              <tbody>
                {
                  i?.current_salary_calculation?.deduction_details
                    ?.filter((j) => !isNaN(j.standard_amount) && !isNaN(j.actual_amount) && j.salaryslip !== false)
                    .sort((a, b) => a.sorting_var - b.sorting_var)
                    .map((j, index) => {
                      const isSpecialRow = j.salary_type === "total" || j.salary_type === "difference";
                      return (
                        <tr key={index} className={isSpecialRow ? "special-row" : "gray-row"}>
                          <td>{j.name}</td>
                          <td className="align-right">{formatCurrencyIndian(j.standard_amount)}</td>
                          <td className="align-right">{formatCurrencyIndian(j.actual_amount)}</td>
                        </tr>
                      );
                    })
                }
              </tbody>
            </table>
            <table className='nested-table-modern'>
              <tbody>
                <tr className="salary-total-row">
                  <td colSpan={1}>SALARY PAY</td>
                  <td colSpan={3}>
                    {
                      // formatCurrencyIndian(
                      //   i?.current_salary_calculation?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                      // )
                      formatCurrencyIndian(
                        Math.round(i?.current_salary_calculation?.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0)
                      )
                    }
                  </td>
                </tr>
                {/* <tr className="salary-total-row in-words-row">
                <td colSpan={1}>IN WORDS</td>
                <td colSpan={3}>
                  {
                    numberToWords.toWords(
                      i.deduction_details.find((j) => j.final_salary === true)?.actual_amount || 0
                    ).toUpperCase()
                  }
                </td>
              </tr> */}<tr className="salary-total-row in-words-row">
                  <td colSpan={1}>IN WORDS</td>
                  <td colSpan={3}>
                    {/* {
                      (() => {
                        const amountStr = i.deduction_details.find((j) => j.final_salary)?.actual_amount;
                        const amount = Number(amountStr.replace(/,/g, ''));
                        if (!isNaN(amount) && isFinite(amount)) {
                          return numberToIndianWords(5000000).toUpperCase() + " ONLY";
                        } else {
                          return "---";
                        }
                      })()
                    } */}
                    {
                      (() => {
                        const detail = i?.current_salary_calculation?.deduction_details.find((j) => j.final_salary);
                        const amountStr = detail?.actual_amount;

                        // if (typeof amountStr === 'number' && isFinite(amountStr)) {
                        //   const amount = amountStr;
                        //   return numberToIndianWords(amount).toUpperCase() || '-';
                        // } else if (typeof amountStr === 'string') {
                        //   const amount = Number(amountStr.replace(/,/g, ''));
                        //   if (!isNaN(amount) && isFinite(amount)) {
                        //     return numberToIndianWords(amount).toUpperCase() || '-';
                        //   }
                        // }

                        if (typeof amountStr === 'number' && isFinite(amountStr)) {
                          const amount = amountStr;
                          return numberToIndianWords(Math.round(amount)).toUpperCase() || '-';
                        } else if (typeof amountStr === 'string') {
                          const amount = Number(amountStr.replace(/,/g, ''));
                          if (!isNaN(amount) && isFinite(amount)) {
                            return numberToIndianWords(Math.round(amount)).toUpperCase() || '-';
                          }
                        }

                        return "---";
                      })()
                    }

                  </td>
                </tr>


              </tbody>
            </table>
            <br />
            <h6 style={{ fontSize: '10px' }}><b>*This is Software generated Salary Slip no signature required*</b></h6>
          </div>
        </div>


        {/* {!letterTemplateData?.footer_full_image && (<div className='salaryslip-hr'></div>)} */}
        {
          letterTemplateData?.footer_full_image && (
            <div className='salaryslip-header salaryslip-footer'
              style={{
                paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
                paddingRight: `${letterTemplateData?.footer_right_gap}px`,
                paddingTop: `${letterTemplateData?.footer_top_gap}px`,
                paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,
                position: 'absolute',
                // bottom: '0',
                width: '-webkit-fill-available',
                backgroundColor: 'white'
              }}
            >
              <img src={`${letterTemplateData?.footer_full_image}`} alt='full Image' className='salaryslip-fullimage increement-s-header-image' />
            </div>
          )
        }


        {
          (letterTemplateData?.footer_logo || letterTemplateData?.footer_company_name || letterTemplateData?.footer_Address || letterTemplateData?.footer_email) &&

          <div className='salaryslip-header salaryslip-footer'
            style={{
              paddingLeft: `${letterTemplateData?.footer_left_gap}px`,
              paddingRight: `${letterTemplateData?.footer_right_gap}px`,
              paddingTop: `${letterTemplateData?.footer_top_gap}px`,
              paddingBottom: `${letterTemplateData?.footer_bottom_gap}px`,
              position: 'absolute',
              width: '-webkit-fill-available',
              backgroundColor: 'white'
            }}
          >
            <div className='salaryslip-header-left'>
              {!letterTemplateData?.footer_full_image && letterTemplateData?.footer_logo ? (
                <img src={letterTemplateData?.footer_logo} alt='logo' className='salaryslip-logo' />
              ) : (
                <div></div>
              )}
            </div>

            <div className='salaryslip-header-right text-end'>
              {letterTemplateData?.footer_company_name && (
                <div className='salaryslip-header-right-top-red font-weight600 font-size-heading' style={{ color: letterTemplateData?.footer_primary_colour || 'black' }}>
                  {letterTemplateData?.footer_company_name}
                </div>
              )}

              {(letterTemplateData?.footer_Address || letterTemplateData?.footer_email) && (
                <>
                  <div style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }} className='salaryslip-header-right-bottom inc-header-address  font-weight400 font-size-subheading letter-address' dangerouslySetInnerHTML={{ __html: letterTemplateData?.footer_Address }} >
                  </div>
                  <span className="letter-address" style={{ color: letterTemplateData?.footer_secondery_colour || '#212529' }}> {letterTemplateData?.footer_email}</span>
                </>
              )}
            </div>
          </div>
        }

      </div>

      {
        letterTemplateData?.bg_image ? (
          <div
            className="aimantra-bg-letter"
            style={{
              backgroundImage: `url(${letterTemplateData?.bg_image})`,
              backgroundSize: `${letterTemplateData?.bg_size}%`,
              backgroundRepeat: 'no-repeat',
              opacity: `${letterTemplateData?.bg_opacity || 100}%`,
              transform: letterTemplateData.bg_angle
                ? `rotate(${letterTemplateData.bg_angle}deg)`
                : "none",
            }}
          ></div>
        )
          :
          (
            <div
              className="aimantra-bg-letter"
              style={{ backgroundImage: `url(${subCompany?.company_logo})` }}
            >
            </div>
          )
      }
      {/* <div className='printSlip-bg'>
      </div> */}
    </div >

  )
});
const PrintDynamicUpcomingSalarySlip = () => {
  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const location = useLocation();
  const urlParts = currentUrl.split('/');
  const filter_subCompany = location.state ? location.state.filters.subCompany : "";
  const filter_status = location.state ? location.state.filters.active : "";
  const filter_CostCenter = location.state ? location.state.filters.selectedCostCenter : "";
  const filter_DataType = location.state ? location.state.filters.selectedDataType : "";
  const filter_Department = location.state ? location.state.filters.selectedDep : "";
  const filter_Designation = location.state ? location.state.filters.selectedDesi : "";
  const filter_Name = location.state ? location.state.filters.selectedName : "";
  const filter_Month = location.state ? location.state.filters.startMonth : "";
  const filter_Year = location.state ? location.state.filters.startYear : "";

  const backUrl = "/" + urlParts[3] + `/payrollmanagement`;


  // const { monthh, yearr } = location.state;
  const { monthh, yearr, filters } = location.state;
  console.log(location.state, "state");

  const togglepayroll = 2;
  const toggleincomingmonth = monthh;
  const toggleincomingyear = yearr;
  const backroute = (togglepayroll) => {
    // navigate(backUrl, { state: { togglepayroll, toggleincomingmonth, toggleincomingyear } })
    navigate(backUrl, {
      state: {
        togglepayroll, toggleincomingmonth, toggleincomingyear,
        filter_subCompany,
        filter_status,
        filter_CostCenter,
        filter_DataType,
        filter_Department,
        filter_Designation,
        filter_Name,
        filter_Month,
        filter_Year,
        // filters
      }
    })
  }

  return (

    <div>
      <div className='flex-column flex-center  slip-container'>
        <div className='printSlip-width flex-row justify-evenly button-margin'>
          <button className="model-button model-button-black font-weight500   " onClick={(e) => { backroute(togglepayroll) }} >Back</button>
          <ReactToPrint
            bodyClass="print-agreement"
            content={() => ref.current}
            trigger={() => (
              <button className="model-button model-button-black">
                <Printer /> Print
              </button>
            )}
          />
        </div>

        <DataSalarySlip ref={ref} />
      </div>
    </div >
  );
};
export default PrintDynamicUpcomingSalarySlip

